<div mat-dialog-title class="d-flex justify-content-between align-items-center">
  <h2 class="m-0">{{ parentData.title }}</h2>
  <button mat-icon-button mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div>
    <mat-form-field appearance="outline" style="width: 100%">
      <mat-label>Amount</mat-label>
      <input
        [(ngModel)]="customerPayment"
        matInput
        smDecimalOnly
        type="number"
      />
    </mat-form-field>
  </div>
  <div
    class="radio_group"
    *ngIf="
      this.parentData.data?.advance_payment_required &&
      this.parentData.data?.advance_payment_required > 0 &&
      this.parentData.data?.customer_payment == 0
    "
  >
    <!-- <label>Advance amount: </label>
          <br /> -->
    <mat-radio-group
      [(ngModel)]="advancePaymentType"
      (change)="changeAdvancePaymentType($event)"
    >
      <div class="flex_numer">
        <div class="add_member_section_radio">
          <mat-radio-button [value]="1">Full payment</mat-radio-button>
        </div>
        <div class="add_member_section_radio">
          <mat-radio-button [value]="2">Advance payment</mat-radio-button>
        </div>
      </div>
    </mat-radio-group>
  </div>
  <div class="chip_cont">
    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selectedPurple: selectedPaymentMode == 'Cash' }"
        (click)="changeChip('Cash')"
        >Cash
      </mat-chip>
    </mat-chip-list>

    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selectedPurple: selectedPaymentMode == 'Online' }"
        (click)="changeChip('Online')"
        >Online
      </mat-chip>
    </mat-chip-list>
    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selectedPurple: selectedPaymentMode == 'Card' }"
        (click)="changeChip('Card')"
        >Card
      </mat-chip>
    </mat-chip-list>
    <mat-chip-list aria-label="Fish selection" class="mb-3">
      <mat-chip
        style="height: auto"
        [ngClass]="{ selectedPurple: selectedPaymentMode == 'Wallet' }"
        (click)="changeChip('Wallet')"
        >Wallet
      </mat-chip>
    </mat-chip-list>
  </div>

  <div *ngIf="toShowWallet" style="margin-top: 15px; margin-bottom: 25px">
    <p>
      Available wallet money: {{ walletCs }}{{ availableWalletCash.toFixed(2) }}
    </p>
  </div>

  <div
    *ngIf="toShowNotify"
    class="add_crt"
    style="display: flex; gap: 20px; margin-bottom: 20px; margin-top: 15px"
  >
    <div class="try">
      <mat-checkbox [(ngModel)]="notify"></mat-checkbox>
      <label
        style="margin-left: 10px; position: relative; top: -3px"
        for="testing1"
        class="check-label"
        >Notify customer/member via WhatsApp and Email.</label
      >
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button style="color: #fff" mat-flat-button color="accent" (click)="onPost()">
    Record payment
  </button>
</mat-dialog-actions>
